import React from 'react';
import { Box, Rating } from '@mui/material';

export default function AddFeedbackStar(props) {
  const onChange = (event, newValue) => {
    props?.onChange(newValue)
  }

  return (
    <Box className='feedbackStarSize'>
      <Rating
        name="size-large"
        readOnly
        value={props?.feedbackData?.starValue || props?.value}
        onChange={(event, newValue) => {
          onChange(event, newValue)
        }}
        size="large"
      />
    </Box>
  );
}